<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import CustomInteractionDefault from './customInteractionTypes/CustomInteractionDefault.svelte';
    import AudioRecordingInteraction from './customInteractionTypes/AudioRecordingInteraction.svelte';
    import VideoRecordingInteraction from './customInteractionTypes/VideoRecordingInteraction.svelte';
    import TextReaderInteraction from './customInteractionTypes/TextReaderInteraction.svelte';
    import GeogebraInteraction from './customInteractionTypes/GeogebraInteraction.svelte';
    import EntryCodeInteraction from './customInteractionTypes/EntryCodeInteraction.svelte';
    import AdvancedTableInteraction from './customInteractionTypes/AdvancedTableInteraction.svelte';
    import './css/tao3xStyles.css';

    /**
     * This component is a simple switcher which selects a PCI handler component based on typeIdentifier,
     * or falls back to the default component (which can handle all IMS PCIs).
     * @property {String} typeIdentifier
     */
    let props = $props();
    // svelte-ignore state_referenced_locally
    let { typeIdentifier = 'default' } = props;

    const customInteractionTypes = Object.freeze({
        default: CustomInteractionDefault,
        audioRecordingInteraction: AudioRecordingInteraction,
        videoRecordingInteraction: VideoRecordingInteraction,
        textReaderInteraction: TextReaderInteraction,
        GGBPCI: GeogebraInteraction,
        entryCodeInteraction: EntryCodeInteraction,
        advancedTableInteraction: AdvancedTableInteraction
    });

    const CustomInteractionComponent = customInteractionTypes[typeIdentifier] || customInteractionTypes.default;
</script>

<CustomInteractionComponent {...props} />
